"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.yearnSdk = void 0;
const providers_1 = require("@ethersproject/providers");
const sdk_1 = require("@yfi/sdk");
// YearnVaultMarketCapService deps
const network = 1; // 1 for mainnet
const provider = new providers_1.JsonRpcProvider(process.env.REACT_APP_ETHEREUM_NODE_URL);
exports.yearnSdk = new sdk_1.Yearn(network, { provider });
